import styled, { css } from "styled-components";
import { primaryColor } from "../../../pages/dash/styles";

export const EventContainer = styled.div`
  padding-bottom: 30px;
  margin: 20px 0;
  width: 100%;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.columns === "2" ? "1fr 1fr" : "1fr"};
  gap: 20px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px 30px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.07);
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  border-bottom: 1px solid #EBEEF2;
  padding-bottom: 10px;
`;

export const InputGroup = styled.div`
  position: relative;
  margin-bottom: 15px;
`;

export const InputLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;

`;

export const Input = ({ icon, ...props }) => (
  <InputWrapper>
    {icon}
    <input {...props} />
  </InputWrapper>
);

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #EBEEF2;
  border-radius: 8px;
  padding: 10px 12px;
  height: 50px;
  background: #fff;
  cursor: pointer;

  svg {
    color: #777;
  }

  input {
    width: 100%;
    border: none;
    outline: none;
    margin-left: 8px;
    background: none;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  border: 1px solid #EBEEF2;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  resize: vertical;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

// ---------------- RADIO BUTTON ----------------
export const RadioButton = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;

  input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  small {
    font-size: 12px;
    color: #6b7280;
    margin-left: 4px;
  }
`;
export const TagsSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Tag = styled.span`
  padding: 10px 18px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
  transition: 0.2s;
`;

export const DatePickerDropdown = styled.div`
  position: absolute;
  top: 75px;
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0,0,0,0.18);
  z-index: 40;
`;

export const TimePickerDropdown = styled.div`
  position: absolute;
  top: 75px;
  background: #fff;
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0,0,0,0.18);
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: 8px;

  span {
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
  }

  span:hover {
    background: #f1f3f5;
  }
`;

export const LocationDropdown = styled.div`
  position: absolute;
  top: 75px;
  background: #fff;
  padding: 8px;
  border-radius: 8px;
  width: 100%;
  box-shadow: 0 4px 18px rgba(0,0,0,0.18);
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: 6px;

  span {
    padding: 8px;
    cursor: pointer;
    border-radius: 6px;
  }

  span:hover {
    background: #f3f4f6;
  }
`;


